import {Provider} from '@oilstone/container';

export default new Provider().register(container => {
    container.singleton('sections', () => {
        return [
            'about',
            'services',
            'contact'
        ];
    });
});
